import {
  getQueryFormat,
  allFleetCalculator,
  sendCalculatorData,
  savePortDistance as savePortDistanceAction,
  updateQueryDetails as updateQueryDetailsAction,
  updateFleetData as updateFleetDataAction,
  addCargoExtraDetails as addCargoExtraDetailsAction,
  deleteCargoExtraDetail as deleteCargoExtraDetailAction,
  deleteFleet as deleteFleetAction,
  updateChangeSwitchQuery as updateChangeSwitchQueryAction,
  resetDistance as resetDistanceAction,
  getPortDistanceByPortList as getPortDistanceByPortListAction,
} from "../../actions";
import { safeArray } from "../utils/validations";

/**
 * Dedicated API service layer for Calculator using standard actions.
 * Ensures 100% compatibility with backend database endpoints.
 */

export const fetchInitialQueriesAndFleet = async ({ offset = 1, perPage = 50 }) => {
  const [queryRes, fleetRes] = await Promise.all([
    getQueryFormat({ isFromCalc: true }),
    allFleetCalculator({ offset, perPage }),
  ]);

  const queries = safeArray(queryRes?.data?.list).filter(Boolean);
  const fleets = safeArray(fleetRes?.data?.list).filter(Boolean);

  return {
    queries,
    fleets,
    currentPage: fleetRes?.data?.currentPage || offset,
    totalItems: fleetRes?.data?.totalItems || 0,
    totalPages: fleetRes?.data?.totalPages || 0,
  };
};

export const fetchPortDistanceMatrix = async (payload) => {
  return getPortDistanceByPortListAction(payload);
};

export const resetPortDistanceMatrix = async (payload) => {
  return resetDistanceAction(payload);
};

export const calculateCargoPriceApi = async (calculationData) => {
  return sendCalculatorData(calculationData);
};

export const savePortDistanceApi = async (saveData) => {
  return savePortDistanceAction(saveData);
};

export const updateQueryDetailsApi = async (queryData) => {
  return updateQueryDetailsAction(queryData);
};

export const updateFleetDataApi = async (fleetData) => {
  return updateFleetDataAction(fleetData);
};

export const addCargoExtraDetailsApi = async (data) => {
  return addCargoExtraDetailsAction(data);
};

export const deleteCargoExtraDetailApi = async (data) => {
  return deleteCargoExtraDetailAction(data);
};

export const deleteFleetApi = async (fleetId) => {
  return deleteFleetAction(fleetId);
};

export const updateChangeSwitchQueryApi = async (data) => {
  return updateChangeSwitchQueryAction(data);
};
